import { useTranslation } from 'react-i18next';
import Dialog, { type DialogProps } from '@fastnorth/kraken/components/dialog';
import { Paragraph } from '@fastnorth/kraken/components/typography';
import handleNotificationPermission from '../../lib/pwa/handleNotificationPermission';
import declineNotifications from '../../lib/pwa/declineNotifications';
import { Bell } from 'lucide-react';

const PushNotificationsDialog = (
  props: Pick<DialogProps, 'open' | 'onOpenChange'>
): React.JSX.Element => {
  const { open, onOpenChange } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'karwa.components.push_notifications_dialog',
  });

  return (
    <Dialog
      open={open}
      onOpenChange={async () => {
        if (onOpenChange) {
          onOpenChange(false);
        }
        await declineNotifications();
      }}
      container={document.getElementById('participant-search')}
      dialogTitle={{
        text: t('dialog_title'),
        icon: <Bell size={16} strokeWidth={2} className={'mr-3'} />,
      }}
      closeButtonText={t('cancel_button')}
      footer={[
        {
          onClick: () => {
            handleNotificationPermission();
          },
          children: t('allow_button'),
        },
      ]}>
      <Paragraph spacing={'4'}>{t('dialog_description')}</Paragraph>
    </Dialog>
  );
};

export default PushNotificationsDialog;
